import type React from 'react';
import { type Group, variant as navVariant } from '@cx-web/domain-types';
import classnames from 'classnames';

import { useDesktopHeaderTracking } from '../../../../context/DesktopHeaderTrackingContext';
import { mergePersistentParams } from '../../../../utils/merge-persistent-params';

import styles from './SplitNavLinks.module.css';

type SplitNavLinksProps = {
  isUkStyle?: boolean;
  links: Group[];
  serverUrl: string;
  variant?: 'secondary' | 'tertiary';
};

const SplitNavLinks = ({ isUkStyle, links, serverUrl, variant }: SplitNavLinksProps): React.JSX.Element => {
  const requestUrl = serverUrl;
  const selectedPath = new URL(serverUrl).pathname;
  const track = useDesktopHeaderTracking();

  return (
    <div
      // Secondary redesign layout gated behind isUkStyle (RENDER_UK_HEADER_STYLE) so it never
      // applies in the legacy header — mirrors CustomDropdown .secondaryDropdownContainer.
      className={classnames(styles.container, variant === 'secondary' && isUkStyle && styles.secondaryContainer)}
      data-testid="split-state-nav-wrapper"
    >
      {links.map(({ items, name }) => {
        if (!items || !items?.length) {
          return null;
        }

        return (
          <div className={styles.navSection} data-testid="split-state-nav-section" key={name}>
            {name ? (
              <div className={styles.navSectionText} data-testid="split-state-nav-title">
                {name}
              </div>
            ) : null}
            <div className={styles.navSectionLinks} data-testid="split-state-nav-links">
              {items.map(({ link, name }) => {
                const isSelected = link === selectedPath;

                return (
                  <a
                    className={classnames(styles.navSectionLink, isSelected ? styles.navSectionLinkSelected : '')}
                    data-testid="split-state-nav-link"
                    href={mergePersistentParams(link, requestUrl)}
                    key={name}
                    // Mobile omits variant and has no desktop tracking callback.
                    onClick={() => track(variant ?? navVariant.tertiary, name)}
                  >
                    {name}
                  </a>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SplitNavLinks;
